import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../utils/queries'
import SeguroPermite from '../../components/funcionales/seguropermite'

// "use strict";

//Documentos

  const DetDocum = ({elemento, tipoCargue}) => {
    if(tipoCargue==="UpdEq"){
      // console.log("Entra UpdEq")
      return(
        <tr className=''>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cedula}</td>          
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCarta}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPrograma}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreImagen}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ordenImagen}</td>
        </tr>
      )
    }else{
      if(tipoCargue==="UpdEqAc"){
        // console.log("Entra UpdEqAc")
        return(
          <tr className=''>
            <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
            <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
            <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
            <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
            <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.acumulado}</td>      
            <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
          </tr>
        )
      }else{
        if(tipoCargue==="Add"){ 
          return(
            <tr className=''>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.consecutivo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codPlanta}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codSeccion}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codEquipo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codComponente}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codMecanismo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUtilidad?elemento.descrUtilidad:''}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadTotal}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidad}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.puntosLub}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.minutos}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.modoTarea?elemento.modoTarea:''}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.requiereSISO?elemento.requiereSISO:''}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuenciaPre}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProx}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codProcedimiento}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codInfoTarea}</td>
            </tr>
          )
        }else{
          return(
            <tr className=''>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codPlanta}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codSeccion}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codEquipo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codComponente}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codMecanismo}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUtilidad}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadTotal}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
              <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.puntosLub}</td>
            </tr>
          )        
        }
      }
    };
  }

const ListaDocum = ({list, tipoCargue}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetDocum elemento={elemento} key={i} tipoCargue={tipoCargue}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class CargEst2 extends React.Component {
  state={listDocum: [], checked: true, permiteUpdate: true, confirmaAct: false, open: false, errors: [],
    argsQuery: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, descrPlanta: 1,
        descrSeccion: '$secciones.descrSeccion',
        descrEquipo: '$secciones.equipos.descrEquipo',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo'}}`,

    argsQuery1: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, descrPlanta: 1,
        descrSeccion: '$secciones.descrSeccion',
        descrEquipo: '$secciones.equipos.descrEquipo',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
        descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea'}}`,

    argsQuery2: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {$project: {_id: 1,
        imagenes: {
          $let: {
            vars: {regImg: { $cond: { if: { $isArray: "$secciones.equipos.imagenes" },
                                          then: { $size: "$secciones.equipos.imagenes" },
                                          else: 0} }
            },
            in: { $cond: { if: { $gt: [ "$$regImg", 0 ] },
                                then: "$secciones.equipos.imagenes",
                                else: [{nombreImagen: null, ordenImagen: null}] } }
        }},
        descrEmpresa: 1, descrPlanta: 1, 
        descrSeccion: '$secciones.descrSeccion', 
        descrEquipo: '$secciones.equipos.descrEquipo', 
        cedula: '$secciones.equipos.cedula', 
        numCarta: '$secciones.equipos.numCarta', descrPrograma: '$secciones.equipos.descrPrograma'}},
      {"$unwind": "$imagenes"},
      {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, 
        descrEquipo: 1, cedula: 1, numCarta: 1, descrPrograma: 1,
        nombreImagen: '$imagenes.nombreImagen', ordenImagen: '$imagenes.ordenImagen'}}`,

    argsQuery3: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, descrPlanta: 1,
        descrSeccion: '$secciones.descrSeccion',
        descrEquipo: '$secciones.equipos.descrEquipo'}}`
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev) => {
    const updState = (listDocum) => {
      this.setState({listDocum, errors: []})
    };
    let errors = []
// console.log(this.props.tipoCargue)
    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        // let response = await this.props.fecha({
        //   variables: {}
        // });
        // const {fechaHoraHoy} = response.data.fecha

        let archcsv = ""
// console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        let tipoCargue = this.props.tipoCargue
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()

          let lines = archivo.split(/\n/)
          let numDoc = 0, linea = 0, listDocum = [], listCadena = [], listDocumRep = []
          // console.log(lines)
          if(tipoCargue==="UpdEq"){
            lines.forEach(line => {
              if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
                linea += 1
                //crear array de campos para cada linea
                let campos = line.split(";")
                let descrEmpresa = campos[0].replace(/^\s+|\s+$/g, '')
                let descrPlanta = campos[1].replace(/^\s+|\s+$/g, '')
                let descrSeccion = campos[2].replace(/^\s+|\s+$/g, '')
                let descrEquipo = campos[3].replace(/^\s+|\s+$/g, '')
                let cedula = campos[4].replace(/^\s+|\s+$/g, '')
                let numCarta = 0
                if(campos[5]){
                  numCarta = campos[5]?parseInt(campos[5].replace(/^\s+|\s+$/g, ''), 10):0
                }
                let descrPrograma = 'Sin programa'
                if(campos[6]){
                  descrPrograma = campos[6].replace(/^\s+|\s+$/g, '')
                }                
                let nombreImagen = ''
                let ordenImagen = 0
                if(campos[7]){
                  nombreImagen = campos[7].replace(/^\s+|\s+$/g, '')
                  ordenImagen = campos[8]?parseInt(campos[8].replace(/^\s+|\s+$/g, ''), 10):0
                }
                listDocum.push({descrEmpresa, descrPlanta, descrSeccion, 
                  descrEquipo, cedula, numCarta, descrPrograma, nombreImagen, ordenImagen})
              }
              numDoc += 1
            })
            listDocum = _.orderBy(listDocum, ['descrEmpresa', 'descrPlanta', 'descrSeccion', 
              'descrEquipo', 'ordenImagen'], ['asc', 'asc', 'asc', 'asc', 'asc'])
            updState(listDocum)
            console.log(listDocum)

          }else{
            if(tipoCargue==="UpdEqAc"){
              lines.forEach(line => {
                if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
                  linea += 1
                  //crear array de campos para cada linea
                  let campos = line.split(";")
                  let descrEmpresa = campos[0].replace(/^\s+|\s+$/g, '')
                  let descrPlanta = campos[1].replace(/^\s+|\s+$/g, '')
                  let descrSeccion = campos[2].replace(/^\s+|\s+$/g, '')
                  let descrEquipo = campos[3].replace(/^\s+|\s+$/g, '')
                  let acumulado = campos[4].replace(/^\s+|\s+$/g, '')
                  let tipoFrecuencia = campos[5].replace(/^\s+|\s+$/g, '')
                  let horasKmPorDia = campos[6].replace(/^\s+|\s+$/g, '')
    
                  listDocum.push({descrEmpresa, descrPlanta, descrSeccion, 
                    descrEquipo, acumulado, horasKmPorDia, tipoFrecuencia})
                }
                numDoc += 1
              })
              listDocum = _.orderBy(listDocum, ['descrEmpresa', 'descrPlanta', 'descrSeccion', 
                'descrEquipo', 'tipoFrecuencia'], ['asc', 'asc', 'asc', 'asc', 'asc'])
              updState(listDocum)
            }else{      
              if(tipoCargue==="Add"){
                lines.forEach(line => {
                  if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
                    linea += 1
                    //crear array de campos para cada linea
                    let campos = line.split(";")
                    if(campos[1] && campos[1]!==''){
                      console.log(linea)
                      console.log(campos)
                      let consecutivo = campos[0]
                      let descrEmpresa = campos[1].replace(/^\s+|\s+$/g, '')
                      let descrPlanta = campos[2].replace(/^\s+|\s+$/g, '')
                      let codPlanta = campos[3].replace(/^\s+|\s+$/g, '')
                      let descrSeccion = campos[4].replace(/^\s+|\s+$/g, '')
                      let codSeccion = campos[5].replace(/^\s+|\s+$/g, '')
                      let descrEquipo = campos[6].replace(/^\s+|\s+$/g, '')
                      let codEquipo = campos[7]?campos[7].replace(/^\s+|\s+$/g, ''):''
                      let numCarta = campos[8]?campos[8].replace(/^\s+|\s+$/g, ''):1
                      let descrPrograma = campos[9].replace(/^\s+|\s+$/g, '')
                      let descrComponente = campos[10].replace(/^\s+|\s+$/g, '')
                      let codComponente = campos[11]?campos[11].replace(/^\s+|\s+$/g, ''):''
                      let descrMecanismo = campos[12].replace(/^\s+|\s+$/g, '')
                      let codMecanismo = campos[13]?campos[13].replace(/^\s+|\s+$/g, ''):''
                      let descrUtilidad = campos[14]?campos[14].replace(/^\s+|\s+$/g, ''):''
                      let descrAplicacion = campos[15]?campos[15].replace(/^\s+|\s+$/g, ''):''
                      // let tipoLub = campos[13].replace(/^\s+|\s+$/g, '')
                      let descrLubricante = campos[16]?campos[16].replace(/^\s+|\s+$/g, ''):''

                      let cantidadTotal=0
                      if(campos[17]!==null && campos[17]!==''){
                        cantidadTotal=campos[17]?campos[17].replace(/\./g,''):0
                        cantidadTotal = cantidadTotal?cantidadTotal.replace(/\,/g,'.'):0;
                        cantidadTotal = parseFloat(cantidadTotal)
                        if(!cantidadTotal){
                          cantidadTotal=0
                        }
                      }

                      let cantidad=0
                      if(campos[18]!==null && campos[18]!==''){
                        cantidad=campos[18]?campos[18].replace(/\./g,''):0
                        cantidad = cantidad?cantidad.replace(/\,/g,'.'):0;
                        cantidad = parseFloat(cantidad)              
                        if(!cantidad){
                          cantidad=0
                        }
                      }
    
                      // let abrevUnidad = campos[16].replace(/^\s+/, '').replace(/^\s+|\s+$/g, '')
                      let abrevUnidad = campos[19]?campos[19].replace(/^\s+|\s+$/g, ''):''
                      let puntosLub = campos[20]
                      let minutos = campos[21]
                      let descrMetodo = campos[22]
                      let descrTarea = campos[23]
                      let modoTarea = campos[24]
                      let requiereSISO = campos[25]
                      let tipoFrecuencia = campos[26]
                      let descrFrecuencia = campos[27]
                      let descrFrecuenciaPre = campos[28]
                      let fechaProx = ''
                      // if(tipoCargue = 'add'){
                      let campoMes = ''
                      let campoDia= ''
                      if(campos[29]!==null && campos[29]!=='' && campos[30]!==null && campos[30]!=='' && campos[31]!==null && campos[31]!==''){
                        let mes = parseInt(campos[30], 10)
                        if(mes < 10){ 
                          campoMes='0' + mes
                        }else{
                          campoMes = mes
                        }
                        let dia = parseInt(campos[31], 10)
                        if(dia < 10){ 
                          campoDia='0' + dia
                        }else{
                          campoDia = dia
                        }
                        fechaProx = campos[29] + '-' + campoMes + '-' + campoDia
                      }
                      let acumProx = campos[32]?parseInt(campos[32]):0
                      let codProcedimiento = campos[33]?campos[33].replace(/^\s+|\s+$/g, ''):''
                      let codInfoTarea = campos[34]?campos[34].replace(/^\s+|\s+$/g, ''):''
                      let enRuta = 'N'
                      let activo = 'S'
                      let fechaUlt = ''
                      let acumUlt = 0

                      let cadena=descrEmpresa + descrPlanta + descrSeccion + descrEquipo + descrComponente + descrMecanismo + descrTarea

                      if(listCadena.length>0){
                        let indexCad = listCadena.findIndex( cadenaBusc => cadenaBusc.cadena===cadena)
                        if(indexCad!==-1){
    console.log(cadena)
    console.log(listCadena)
                          errors.push({path: "Cargue", message: `Línea: ${linea + 1} REGISTRO REPETIDO: ${cadena}}`});
                        }
                      }
                      listCadena.push({cadena})

                      listDocum.push({consecutivo, descrEmpresa, descrPlanta, codPlanta, descrSeccion, codSeccion,
                        descrEquipo, codEquipo, numCarta, descrPrograma, descrComponente, codComponente, descrMecanismo, codMecanismo, descrUtilidad, descrAplicacion, 
                        descrLubricante, cantidadTotal, cantidad, abrevUnidad, puntosLub, minutos, descrMetodo, descrTarea, modoTarea, requiereSISO,
                        tipoFrecuencia, descrFrecuencia, descrFrecuenciaPre, fechaProx, acumProx, fechaUlt, acumUlt, codProcedimiento
                        , codInfoTarea
                        , enRuta, activo})
                    }
                  }
                  numDoc += 1
                })
                listDocum = _.orderBy(listDocum, ['descrEmpresa', 'descrPlanta', 'descrSeccion', 'descrEquipo',
                'descrComponente', 'descrMecanismo', 'descrMetodo', 'descrTarea'], ['asc', 'asc', 'asc', 'asc', 'asc',
                'asc', 'asc', 'asc'])

                if(errors.length===0){
                  updState(listDocum)
                  alert("!! Archivo sin duplicados ...OK !!")
                }else{
                  alert("!! Archivo con registros duplicados !!")
                }
                console.log(errors)
      
              }else{
                lines.forEach(line => {
                  if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
                    linea += 1
                    //crear array de campos para cada linea
                    let campos = line.split(";")
                    let descrEmpresa = campos[0].replace(/^\s+|\s+$/g, '')
                    let descrPlanta = campos[1].replace(/^\s+|\s+$/g, '')
                    let codPlanta = campos[2].replace(/^\s+|\s+$/g, '')
                    let descrSeccion = campos[3].replace(/^\s+|\s+$/g, '')
                    let codSeccion = campos[4].replace(/^\s+|\s+$/g, '')
                    let descrEquipo = campos[5].replace(/^\s+|\s+$/g, '')
                    let codEquipo = campos[6].replace(/^\s+|\s+$/g, '')
                    // let numCarta = campos[6].replace(/^\s+|\s+$/g, '')
                    let descrComponente = campos[7].replace(/^\s+|\s+$/g, '')
                    let codComponente = campos[8].replace(/^\s+|\s+$/g, '')
                    let descrMecanismo = campos[9].replace(/^\s+|\s+$/g, '')
                    let codMecanismo = campos[10].replace(/^\s+|\s+$/g, '')
                    let descrUtilidad = campos[11]?campos[11].replace(/^\s+|\s+$/g, ''):''
                    let descrAplicacion = campos[12].replace(/^\s+|\s+$/g, '')
                    let descrLubricante = campos[13].replace(/^\s+|\s+$/g, '')
                    let tipoFrecuencia = campos[14].replace(/^\s+|\s+$/g, '')

                    let cantidadTotal=0
                    if(campos[15]!==null && campos[15]!==''){
                      cantidadTotal=campos[15].replace(/\./g,'')
                      cantidadTotal = cantidadTotal.replace(/\,/g,'.');
                      cantidadTotal = parseFloat(cantidadTotal)
                      if(!cantidadTotal){
                        cantidadTotal=0
                      }
                    }

                    let abrevUnidad = campos[16].replace(/^\s+|\s+$/g, '')
                    // let puntosLub = campos[15]
                    // let minutos = campos[16]

                  listDocum.push({descrEmpresa, descrPlanta, codPlanta, descrSeccion, codSeccion,
                    descrEquipo, codEquipo, descrComponente, codComponente, descrMecanismo, codMecanismo, descrUtilidad, descrAplicacion, 
                    descrLubricante, tipoFrecuencia, cantidadTotal, abrevUnidad})
                  }
                numDoc += 1
                })

                listDocum = _.orderBy(listDocum, ['descrEmpresa', 'descrPlanta', 'descrSeccion', 'descrEquipo',
                'descrComponente', 'descrMecanismo'], ['asc', 'asc', 'asc', 'asc', 'asc',
                'asc', 'asc', 'asc'])  
                updState(listDocum)

              }
            }
          };
        }  
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
        this.setState({checked: checkTieneEncab})
      }else{
        this.setState({listDocum: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listDocum)=>{
    let mecanismos = []
    let argsBuscarMec = {tipoqry: `[${this.state.argsQuery3}]`}
    let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarMec)
    mecanismos = await data.allPlantaRtes
    console.log(this.props.allInfoTarea.allInfoTarea)
    let allInfoTarea = this.props.allInfoTarea.allInfoTarea
    console.log(allInfoTarea)
    
    if(this.props.tipoCargue==="UpdEq"){
      document.body.style.cursor = 'wait'
      //PROCESO CARGAR ACTUALIZAR ORDEN DE NUMEROS DE CARTA E IMAGENES
      let imagenes = []
      let argsBuscarImg = {tipoqry: `[${this.state.argsQuery2}]`}
      let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarImg)
      imagenes = await data.allPlantaRtes
      let errors = []
      if(listDocum.length===0){
        errors.push({path: "Cargue", message: "No hay información"});
      }

      this.setState({errors})
      if(errors.length===0){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        let updColeccEq = []
        let argsImg = {}, updColeccImg = []
        let argsEqu = {}
        let lineaDoc = 0
        let allUsuarios = await this.props.allUsuarios.allUsuarios
        let allProgramas = await this.props.allPrograma.allPrograma

        console.log(listDocum)
        listDocum.forEach(async (elemento, i) => {
        // for(let i=0; i<listDocum.length; i++){
          // console.log(listDocum[i])
          let argsBuscarPl = {}
          let regExiste = []
          let argsBuscarImg = {}
          let regExisteImg = []
          let argsBuscar = ""
          // let descrEmpresa = listDocum[i].descrEmpresa, descrPlanta = listDocum[i].descrPlanta
          // let descrSeccion = listDocum[i].descrSeccion, descrEquipo = listDocum[i].descrEquipo
          let descrEmpresa = elemento.descrEmpresa, descrPlanta = elemento.descrPlanta
          let descrSeccion = elemento.descrSeccion, descrEquipo = elemento.descrEquipo
          // let cedula = listDocum[i].cedula?listDocum[i].cedula:""
          // let numCarta = listDocum[i].numCarta?listDocum[i].numCarta:0
          // let nombreImagen = listDocum[i].nombreImagen?listDocum[i].nombreImagen:""
          // let ordenImagen = listDocum[i].ordenImagen?listDocum[i].ordenImagen:0
          let cedula = elemento.cedula?elemento.cedula:""
          let numCarta = elemento.numCarta?elemento.numCarta:0
          let descrPrograma = elemento.descrPrograma?elemento.descrPrograma:'Sin programa'
          let nombreImagen = elemento.nombreImagen?elemento.nombreImagen:""
          let ordenImagen = elemento.ordenImagen?elemento.ordenImagen:0
console.log(descrPrograma)
          if(!descrEmpresa){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la empresa`});
          }
          if(!descrPlanta){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la planta`});
          }
          if(!descrSeccion){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la sección`});
          }
          if(!descrEquipo){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del equipo`});
          }
          if(!cedula){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del operario del equipo`});
          }          
          // if(numCarta===0){
          //   errors.push({path: "Cargue", message: `Línea: ${i + 1} El número de carta no es valido`});
          // }
          if(descrEquipo){
            // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
            // argsBuscar += `, 'descrSeccion': '${descrSeccion}', 'descrEquipo': '${descrEquipo}'`
            // argsBuscarPl = {}
            // argsBuscarPl = {tipoqry: `[${this.state.argsQuery3}, {$match: {${argsBuscar}}}]`}
            // regExiste = []
            // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
            // regExiste = await data.allPlantaRtes


            let indexEq = mecanismos.findIndex( mecanismo => mecanismo.descrEmpresa===descrEmpresa && mecanismo.descrPlanta===descrPlanta && mecanismo.descrSeccion===descrSeccion && mecanismo.descrEquipo===descrEquipo)
            if(indexEq===-1){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} EQUIPO NO EXISTE: ${descrPlanta} ${descrSeccion} ${descrEquipo}`});
            }

            // if(regExiste.length===0){
            //   errors.push({path: "Cargue", message: `Línea: ${i + 1} El equipo no existe ${descrPlanta} ${descrSeccion} ${descrEquipo}`});
            // }else{
              lineaDoc = i
                argsEqu['descrEmpresa'] = descrEmpresa
                argsEqu['descrPlanta'] = descrPlanta
                argsEqu['descrSeccion'] = descrSeccion
                argsEqu['descrEquipo'] = descrEquipo
                argsEqu['cedula'] = cedula                                
                argsEqu['numCarta'] = parseInt(numCarta)
                argsEqu['tipoAct'] = "EditarNumCarta" 

                let indexOpe = allUsuarios.findIndex( operario => operario.cedula===cedula )
                if(indexOpe===-1){
                  errors.push({path: i + " Cargue", message: `El operario con cedula ${cedula} no ha sido creado`});
                  argsEqu['nombreUsuario'] = ''
                }else{
                  argsEqu['nombreUsuario'] = allUsuarios[indexOpe].nombreUsuario
                }

                let indexPro = allProgramas.findIndex( programa => programa.descrPrograma===descrPrograma )
                if(indexPro===-1){
                  errors.push({path: i + " Cargue", message: `El programa ${descrPrograma} no ha sido creado`});
                  argsEqu['descrPrograma'] = ''
                }else{
                  argsEqu['descrPrograma'] = allProgramas[indexPro].descrPrograma
                }

                updColeccEq.push(argsEqu)
                argsEqu = {}
 
              if(nombreImagen){
                // argsBuscar += `, 'nombreImagen': '${nombreImagen}'`
                // argsBuscarImg = {}
                // argsBuscarImg = {tipoqry: `[${this.state.argsQuery2}, {$match: {${argsBuscar}}}]`}
                // regExisteImg = []
                // let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarImg)
                // regExisteImg = await data.allPlantaRtes


                let indexImg = imagenes.findIndex( imagen => imagen.descrEmpresa===descrEmpresa && imagen.descrPlanta===descrPlanta && imagen.descrSeccion===descrSeccion && imagen.descrEquipo===descrEquipo && imagen.nombreImagen===nombreImagen)
                if(indexImg===-1){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} EQUIPO NO EXISTE: ${descrPlanta} ${descrSeccion} ${descrEquipo}}`});
                }                
                // if(regExisteImg.length===0){
                //   errors.push({path: "Cargue", message: `Línea: ${i + 1} La imagen no existe ${descrPlanta} ${descrSeccion} ${descrEquipo} ${nombreImagen}`});
                // }else{
                    argsImg['descrEmpresa'] = descrEmpresa
                    argsImg['descrPlanta'] = descrPlanta
                    argsImg['descrSeccion'] = descrSeccion
                    argsImg['descrEquipo'] = descrEquipo
                    argsImg['nombreImagen'] = nombreImagen
                    argsImg['ordenImagen'] = ordenImagen
                    argsImg['tipoAct'] = "EditarImagen"
                    updColeccImg.push(argsImg)
                    argsImg = {}
                // }
              }
            // }
          }
        // }
        })
console.log('OK')
        if(errors.length>0){
          this.setState({errors})
        }else{
          let numDocCRUD = 0
          let totDocCRUD = updColeccEq.length + updColeccImg.length
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editPlantaUpdSeccion)
          }  
          console.log(updColeccEq)
          for(let iii=0; iii<updColeccEq.length; iii++){
            argsCrud[numDocCRUD] = updColeccEq[iii]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion
      
            numDocCRUD += 1
          }
          // console.log(updColeccImg)
          for(let iii=0; iii<updColeccImg.length; iii++){
            argsCrud[numDocCRUD] = updColeccImg[iii]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion

            numDocCRUD += 1
          }
          console.log(crudColecc)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)

          this.setState({listDocum: []})
        }

        document.body.style.cursor = 'default'

        if(errors.length===0){
          alert("!! Carga exitosa !!")
        }
      }
    }else{
      if(this.props.tipoCargue==="UpdEqAc"){
        document.body.style.cursor = 'wait'
        //PROCESO CARGAR ACTUALIZAR LOS ACUMULADOS DE HORAS O KM DE LOS EQUIPOS
        let errors = []
        if(listDocum.length===0){
          errors.push({path: "Cargue", message: "No hay información"});
        }
  
        this.setState({errors})
        if(errors.length===0){
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
  
          let updColeccEq = []
          let argsImg = {}, updColeccImg = []
          let argsEqu = {}
          let lineaDoc = 0
          let allUsuarios = this.props.allUsuarios.allUsuarios
  
          listDocum.forEach(async (elemento, i) => {
          // for(let i=0; i<listDocum.length; i++){
            let argsBuscarPl = {}
            let regExiste = []
            let argsBuscar = ""
            // let descrEmpresa = listDocum[i].descrEmpresa, descrPlanta = listDocum[i].descrPlanta
            // let descrSeccion = listDocum[i].descrSeccion, descrEquipo = listDocum[i].descrEquipo
            // let acumulado = listDocum[i].acumulado?listDocum[i].acumulado:0
            // let horasKmPorDia = listDocum[i].horasKmPorDia?listDocum[i].horasKmPorDia:0
            let descrEmpresa = elemento.descrEmpresa, descrPlanta = elemento.descrPlanta
            let descrSeccion = elemento.descrSeccion, descrEquipo = elemento.descrEquipo
            let acumulado = elemento.acumulado?elemento.acumulado:0
            let horasKmPorDia = elemento.horasKmPorDia?elemento.horasKmPorDia:0

            if(!descrEmpresa){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la empresa`});
            }
            if(!descrPlanta){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la planta`});
            }
            if(!descrSeccion){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la sección`});
            }
            if(!descrEquipo){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del equipo`});
            }
            if(!acumulado){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del acumulado del equipo`});
            }          
            if(!horasKmPorDia){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de horas/Km Por Dia del equipo`});
            }          
            if(descrEquipo){
              // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
              // argsBuscar += `, 'descrSeccion': '${descrSeccion}', 'descrEquipo': '${descrEquipo}'`
              // argsBuscarPl = {}
              // argsBuscarPl = {tipoqry: `[${this.state.argsQuery3}, {$match: {${argsBuscar}}}]`}
              // regExiste = []
              // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
              // regExiste = await data.allPlantaRtes
  
              // if(regExiste.length===0){
              //   errors.push({path: "Cargue", message: `Línea: ${i + 1} El equipo no existe`});
              // }else{
                let indexEq = mecanismos.findIndex( mecanismo => mecanismo.descrEmpresa===descrEmpresa && mecanismo.descrPlanta===descrPlanta && mecanismo.descrSeccion===descrSeccion && mecanismo.descrEquipo===descrEquipo)
                if(indexEq===-1){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} EQUIPO NO EXISTE: ${descrPlanta} ${descrSeccion} ${descrEquipo}`});
                }  
                lineaDoc = i
                argsEqu['descrEmpresa'] = descrEmpresa
                argsEqu['descrPlanta'] = descrPlanta
                argsEqu['descrSeccion'] = descrSeccion
                argsEqu['descrEquipo'] = descrEquipo
                argsEqu['acumulado'] = parseInt(acumulado, 10)  
                argsEqu['fechaAcum'] = fechaHoraHoy
                argsEqu['usuarioAcum'] = localStorage.getItem('userLogin')
                argsEqu['horasKmPorDia'] = parseInt(horasKmPorDia, 10)  
                argsEqu['tipoAct'] = "EditarAcum"

                updColeccEq.push(argsEqu)
                argsEqu = {}
              // }
            }
          // }
          })
  console.log(updColeccEq)
          if(errors.length>0){
            this.setState({errors})
          }else{
            let numDocCRUD = 0
            let totDocCRUD = updColeccEq.length
            let argsCrud = []
            let crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editPlantaUpdSeccion)
            }  
            
            for(let iii=0; iii<updColeccEq.length; iii++){
              argsCrud[numDocCRUD] = updColeccEq[iii]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion
        
              numDocCRUD += 1
            }
console.log(argsCrud)
            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
  
            this.setState({listDocum: []})
          }
  
          document.body.style.cursor = 'default'
  
          if(errors.length===0){
            alert("!! Carga exitosa !!")
          }
        }
      }else{      
        if(this.props.tipoCargue==="Add"){
          const llenar_argsMec1 = (allLubricante, allFrecuencia, allUnidad, allAplicacion, allUtilidad, allGrado, descrFrecuencia, abrevUnidad) => {
          console.log(allAplicacion)

            let argsMec = {}
            argsMec['tipoLub'] = allLubricante.tipoLub
            argsMec['claseLub'] = allLubricante.claseLub
            argsMec['descrFabricante'] = allLubricante.descrFabricante
            argsMec['categoriaLub'] = allLubricante.categoriaLub
            argsMec['tipoGrado'] = allLubricante.tipoGrado
            argsMec['descrGrado'] = allLubricante.descrGrado
            argsMec['colorGrado'] = allLubricante.colorGrado
            argsMec['apiSAE'] = allLubricante.apiSAE?allLubricante.apiSAE:""
            argsMec['colorAplicacion'] = allAplicacion.color
            argsMec['colorTexto'] = allGrado.colorTexto
            argsMec['isoGrasa'] = allLubricante.isoGrasa?allLubricante.isoGrasa:""
            argsMec['isoGrasaColor'] = allLubricante.isoGrasaColor?allLubricante.isoGrasaColor:""
            argsMec['isoGrasaTexto'] = allLubricante.isoGrasaTexto?allLubricante.isoGrasaTexto:""
            
            let indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===descrFrecuencia )
            if(indexFrec===-1){
              argsMec['abrevUnidadTF'] = ''
            }else{
              argsMec['abrevUnidadTF'] = allFrecuencia[indexFrec].abrevUnidad
            }

            let indexUnd = allUnidad.findIndex( unidad => unidad.abrevUnidad===abrevUnidad )
            if(indexUnd===-1){
              errors.push({path: "Cargue", message: `Consecutivo: ${listDocum.consecutivo} => La unidad ${abrevUnidad} no ha sido creada`});
              argsMec['descrUnidad'] = ''
            }else{
              argsMec['descrUnidad'] = allUnidad[indexUnd].descrUnidad
            }

            return argsMec
          };

          const llenar_argsMec2 = (listDocum, addColeccProg, fechaHoraHoy) => {
            let argsMec = {}

            argsMec['codMecanismo'] = listDocum.codMecanismo
            argsMec['descrMecanismo'] = listDocum.descrMecanismo
            argsMec['tipoFrecuencia'] = listDocum.tipoFrecuencia
            argsMec['descrUtilidad'] = listDocum.descrUtilidad
            argsMec['descrAplicacion'] = listDocum.descrAplicacion
            argsMec['descrLubricante'] = listDocum.descrLubricante
            argsMec['cantidadTotal'] = listDocum.cantidadTotal
            argsMec['abrevUnidad'] = listDocum.abrevUnidad

            argsMec['enInfLabNuevo'] = false
            if(listDocum.descrMetodo && listDocum.descrTarea){

              argsMec['programacion'] = addColeccProg
            }
            argsMec['fechaCreate'] = fechaHoraHoy
            argsMec['usuarioCreate'] = localStorage.getItem('userLogin')

            return argsMec
          };

          const llenar_argsProg = (listMt, allProcEjec, allInfoTarea, fechaHoraHoy) => {
            let argsProg = {}
    // console.log(allProcEjec)
            if(listMt.descrMetodo&&listMt.descrTarea){
              argsProg['consecutivo'] = listMt.consecutivo
              argsProg['cantidad'] = listMt.cantidad
              argsProg['puntosLub'] = listMt.puntosLub
              argsProg['minutos'] = listMt.minutos
              argsProg['descrMetodo'] = listMt.descrMetodo
              argsProg['descrTarea'] = listMt.descrTarea
              argsProg['modoTarea'] = listMt.modoTarea?listMt.modoTarea:''
              argsProg['requiereSISO'] = listMt.requiereSISO?listMt.requiereSISO:''
              argsProg['descrFrecuencia'] = listMt.descrFrecuencia
              argsProg['descrFrecuenciaPre'] = listMt.descrFrecuenciaPre
              // argsProg['fechaProx'] = listMt.fechaProx?listMt[0].fechaProx:null
              argsProg['fechaProx'] = listMt.fechaProx?listMt.fechaProx:null
              argsProg['acumProx'] = listMt.acumProx?parseInt(listMt.acumProx):0
              argsProg['fechaUlt'] = listMt.fechaUlt?listMt.fechaUlt:null
              argsProg['acumUlt'] = listMt.acumUlt?listMt.acumUlt:0            
              argsProg['codProcedimiento'] = listMt.codProcedimiento.replace(/(\r\n|\n|\r)/gm,"")
              argsProg['codInfoTarea'] = listMt.codInfoTarea?listMt.codInfoTarea.replace(/(\r\n|\n|\r)/gm,""):''
              argsProg['enRuta'] = 'N'
              argsProg['activo'] = 'S'
              argsProg['fechaCreate'] = fechaHoraHoy
              argsProg['usuarioCreate'] = localStorage.getItem('userLogin')

              let indexProc = allProcEjec.findIndex( procejec => procejec.codProcedimiento==listMt.codProcedimiento.replace(/(\r\n|\n|\r)/gm,"") )
              if(indexProc===-1){
                argsProg['nombreArchivo'] = ''
              }else{
                argsProg['nombreArchivo'] = allProcEjec[indexProc].nombreArchivo
              }
              if(listMt.codInfoTarea){
                console.log(allInfoTarea)
                console.log(listMt.codInfoTarea)
                let indexInfo = allInfoTarea.findIndex( infotarea => infotarea.codInfoTarea==listMt.codInfoTarea.replace(/(\r\n|\n|\r)/gm,"") )
                if(indexInfo===-1){
                  argsProg['nombreArchivoInfo'] = ''
                }else{
                  argsProg['nombreArchivoInfo'] = allInfoTarea[indexInfo].nombreArchivoInfo
                }    
              }else{
                argsProg['nombreArchivoInfo'] = ''
              }      
            }

            return argsProg
          };

          const llenar_argsComp = (listDocum, addColeccMec, fechaHoraHoy) => {
            let argsComp = {}

            argsComp['codComponente'] = listDocum.codComponente
            argsComp['descrComponente'] = listDocum.descrComponente
            argsComp['mecanismos'] = addColeccMec
            argsComp['fechaCreate'] = fechaHoraHoy
            argsComp['usuarioCreate'] = localStorage.getItem('userLogin')

            return argsComp
          };

          let errors = []
          if(listDocum.length===0){
            errors.push({path: "Cargue", message: "No hay información"});
          }
          if(!this.props.allLubricante.allLubricante){
            errors.push({path: "Lubricantes", message: "Proceso de cargue de la información, por favor espere un momento..."});
          }

          this.setState({errors})
          if(errors.length===0){
            let allEmpresa = this.props.allEmpresa.allEmpresa
            let allLubricante = this.props.allLubricante.allLubricante
            let allAplicacion = this.props.allAplicacion.allAplicacion
            let allFrecuencia = this.props.allFrecuencia.allFrecuencia
            let allUtilidad = this.props.allUtilidad.allUtilidad
            let allUnidad = this.props.allUnidad.allUnidad
            let allMetodo = this.props.allMetodo.allMetodo
            let allTarea = this.props.allTarea.allTarea
            let allGrado = this.props.allGrado.allGrado
            let allProcEjec = this.props.allProcEjec.allProcEjec
            let Empresa = listDocum[0].descrEmpresa
            let argsBuscar1 = `'descrEmpresa': '${Empresa}'`
            let argsBuscarPl1 = {}
            argsBuscarPl1 = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar1}}}]`}
            let allPlanta = []
            let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl1)
            if(data.allPlantaRtes){
              allPlanta = await data.allPlantaRtes
            }
      //PROCESO CARGAR ESTRUCTURA
            document.body.style.cursor = 'wait'

            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            let addColeccPl = []

            let argsProg = {}, addColeccProg = []
            let argsMec = {}, argsMec1 = {}, argsMec2 = {}, addColeccMec = []
            let argsComp = {}, addColeccComp = []
            let argsEqu = {}, addColeccEqu = []
            let argsSecc = {}, addColeccSecc = []
            let argsPl = {}
            let lineaDoc = 0
    // console.log(listDocum)
            for(let i=0; i<listDocum.length; i++){
console.time(1)
console.log("Inicia Registro ", i)
              let tipoCargue = "Add"
              let argsBuscarPl = {}
              let regExiste = []

              let argsBuscar = ""
              let descrEmpresa = listDocum[i].descrEmpresa, descrPlanta = listDocum[i].descrPlanta
              let descrSeccion = listDocum[i].descrSeccion, descrEquipo = listDocum[i].descrEquipo
              let descrComponente = listDocum[i].descrComponente, descrMecanismo = listDocum[i].descrMecanismo
              let descrMetodo = listDocum[i].descrMetodo 
              let descrTarea = listDocum[i].descrTarea, modoTarea = listDocum[i].modoTarea, requiereSISO = listDocum[i].requiereSISO
              let codProcedimiento = listDocum[i].codProcedimiento
              let codInfoTarea = listDocum[i].codInfoTarea?listDocum[i].codInfoTarea:''
              let descrFrecuencia = listDocum[i].descrFrecuencia
// console.log(listDocum)
// console.log(descrEquipo, descrComponente)
              if(!descrEmpresa){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Empresa NO REPORTADA`});
              }
              if(!descrPlanta){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Planta NO REPORTADA`});
              }
              if(!descrSeccion){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Sección NO REPORTADA 847`});
              }
              if(!descrEquipo){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Equipo NO REPORTADO 850`});
              }
              if(!descrComponente){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Componente NO REPORTADO 853`});
              }
              if(!descrMecanismo){
                console.log(descrEquipo, descrComponente)
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Mecanismo NO REPORTADO 856`});
              }

              if(this.props.tipoCargue==="Add"){
                let tipoFrecuencia = listDocum[i].tipoFrecuencia
                if(!tipoFrecuencia || (tipoFrecuencia!=='Calendario' && tipoFrecuencia!=='Horas' && tipoFrecuencia!=='Km')){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} El tipo de frecuencia solo puede ser: Calendario, Horas o Km`});
                }
              }
              if((this.props.tipoCargue==="Upd" && (!descrMetodo || !descrTarea)) ||
                  (this.props.tipoCargue==="Add" && ((!descrMetodo&&descrTarea) || (descrMetodo&&!descrTarea)))){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} Método o Tarea NO especificados`});
              }else{
console.time(2)      
console.log("Inicia 2")
                
                // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
                // argsBuscar += `, 'descrSeccion': '${descrSeccion}', 'descrEquipo': '${descrEquipo}'`
                // argsBuscar += `, 'descrComponente': '${descrComponente}', 'descrMecanismo': '${descrMecanismo}'`
                // argsBuscarPl = {}
                // argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
                // regExiste = []
                // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                // regExiste = await data.allPlantaRtes

                let indexMec = allPlanta.findIndex( empresa => empresa.descrEmpresa===listDocum[i].descrEmpresa && empresa.descrPlanta===listDocum[i].descrPlanta &&
                  empresa.descrSeccion===listDocum[i].descrSeccion && empresa.descrEquipo===listDocum[i].descrEquipo &&
                  empresa.descrComponente===listDocum[i].descrComponente && empresa.descrMecanismo===listDocum[i].descrMecanismo)

console.timeEnd(2)      
console.log("Finaliza 2")
                                
                // if(regExiste.length>0 && this.props.tipoCargue==="Add"){
                if(indexMec!==-1 && this.props.tipoCargue==="Add"){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} MECANISMO YA EXISTE`});
                }
                // if(regExiste.length===0 && this.props.tipoCargue==="Upd"){
                if(indexMec===-1 && this.props.tipoCargue==="Upd"){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} MECANISMO NO EXISTE`});
                }          
                if(this.props.tipoCargue==="Upd"){
                  if(descrMetodo && descrTarea){
                    argsBuscar += `, 'descrMetodo': '${descrMetodo}', 'descrTarea': '${descrTarea}'`
                  }
                  argsBuscarPl = {}
                  argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
                  // console.log(argsBuscarPl)
                  regExiste = []
                  let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
                  regExiste = await data.allPlantaRtes
                  if(regExiste.length===0){
                    tipoCargue="Upd_Add"
                    console.log(regExiste)
                  }else{
                    tipoCargue="Upd_Upd"
                    console.log(regExiste)
                  }
                }
              }

              lineaDoc = i
              let listMt = listDocum.filter(elemento => elemento.descrEmpresa===descrEmpresa&&
                  elemento.descrPlanta===descrPlanta&&elemento.descrSeccion===descrSeccion&&
                  elemento.descrEquipo===descrEquipo&&elemento.descrComponente===descrComponente&&
                  elemento.descrMecanismo===descrMecanismo)

              if(tipoCargue!=="Add"){
console.time(3)      
console.log("Inicia 3")
      //UPD
                let indexMet = allMetodo.findIndex( metodo => metodo.descrMetodo===descrMetodo )
                if(indexMet===-1){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} => El método ${descrMetodo} no ha sido creado`});
                }
                let indexTarea = allTarea.findIndex( tarea => tarea.descrTarea===descrTarea )
                if(indexTarea===-1){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} => La tarea ${descrTarea} no ha sido creada`});
                }
                codProcedimiento = codProcedimiento.replace(/(\r\n|\n|\r)/gm,"")
                if (codProcedimiento!==null && codProcedimiento!==''){
                  let indexProc = allProcEjec.findIndex( procejec => procejec.codProcedimiento==codProcedimiento )
                  if(indexProc===-1){
                    errors.push({path: "Cargue", message: `Línea: ${i + 1} => El procedimiento ${codProcedimiento} no ha sido creado`});
                  }   
                }     
                if(codInfoTarea && codInfoTarea!==''){
                  codInfoTarea = codInfoTarea.replace(/(\r\n|\n|\r)/gm,"")
                  if (codInfoTarea!==null && codInfoTarea!==''){
                    let indexInfo = allInfoTarea.findIndex( infotarea => infotarea.codInfoTarea==codInfoTarea )
                    if(indexInfo===-1){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => El código de advertencia ${codInfoTarea} no ha sido creado`});
                    }   
                  }
                }
                argsProg = llenar_argsProg(listDocum[i], allProcEjec, allInfoTarea, fechaHoraHoy)
                // argsProg = llenar_argsProg(listDocum[i], allProcEjec, fechaHoraHoy)
                addColeccProg.push(argsProg)
                argsProg = {}

console.timeEnd(3)      
console.log("Finaliza 3")

                argsPl['descrEmpresa'] = descrEmpresa
                argsPl['descrPlanta'] = descrPlanta
                argsPl['descrSeccion'] = descrSeccion
                argsPl['descrEquipo'] = descrEquipo
                argsPl['descrComponente'] = descrComponente
                argsPl['descrMecanismo'] = descrMecanismo
                argsPl['descrMetodo'] = descrMetodo
                argsPl['descrTarea'] = descrTarea
                argsPl['descrMetodoAnt'] = descrMetodo
                argsPl['descrTareaAnt'] = descrTarea
                argsPl['programacion'] = addColeccProg
                if(tipoCargue==="Upd_Add"){
                  argsPl['tipoAct'] = "CrearProgramacion"
                }
                if(tipoCargue==="Upd_Upd"){
                  argsPl['tipoAct'] = "EditarProgramacion"
                }
                addColeccPl.push(argsPl)
                argsPl = {}
                addColeccProg = []
      //FIN UPD
              }
              if(tipoCargue==="Add"){
      //ADD
console.time(4)      
console.log("Inicia 4")
                for(let ii=0; ii<listMt.length; ii++){
                  console.log(listMt[i])
                  let indexEmp = allEmpresa.findIndex( empresa => empresa.descrEmpresa===listDocum[i].descrEmpresa.replace(/^\s+|\s+$/g, ''))
                  let indexLub = allLubricante.findIndex( lubricante => lubricante.descrLubricante===listDocum[i].descrLubricante.replace(/^\s+|\s+$/g, ''))
                  let indexAp = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===listDocum[i].descrAplicacion.replace(/^\s+|\s+$/g, ''))
                  let indexUt = allUtilidad.findIndex( utilidad => utilidad.descrUtilidad===listDocum[i].descrUtilidad.replace(/^\s+|\s+$/g, ''))

                  if(indexEmp===-1){
                    errors.push({path: "Cargue", message: `Línea: ${i + 1} => Consecutivo: ${listDocum[i].consecutivo?listDocum[i].consecutivo:i} => La empresa ${listDocum[i].descrEmpresa} no ha sido creada`});
                  }else{ 
                    if(indexAp===-1){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => Consecutivo: ${listDocum[i].consecutivo?listDocum[i].consecutivo:i} => La aplicación ${listDocum[i].descrAplicacion} no ha sido creada`});
                    }else{            
                      if(indexLub===-1){
                        errors.push({path: "Cargue", message: `Línea: ${i + 1} => Consecutivo: ${listDocum[i].consecutivo?listDocum[i].consecutivo:i} => El lubricante ${listDocum[i].descrLubricante} no ha sido creado`});
                      }else{
                        let indexGr = allGrado.findIndex( grado => grado.tipoGrado===allLubricante[indexLub].tipoGrado && grado.descrGrado===allLubricante[indexLub].descrGrado)
                        if(indexGr===-1){
                          errors.push({path: "Cargue", message: `Línea: ${i + 1} => Consecutivo: ${listDocum[i].consecutivo?listDocum[i].consecutivo:i} => El lubricante ${listDocum[i].descrLubricante} no tiene Grado`});
                        }else{
                          if(indexUt===-1){
                            errors.push({path: "Cargue", message: `Línea: ${i + 1} => Consecutivo: ${listDocum[i].consecutivo?listDocum[i].consecutivo:i} => El tipo de mecanismo ${listDocum[i].descrUtilidad} no existe`});
                          }else{
                            argsMec1 = llenar_argsMec1(allLubricante[indexLub], allFrecuencia, allUnidad, allAplicacion[indexAp], allUtilidad[indexUt], 
                            allGrado[indexGr], listDocum[i].descrFrecuencia, listDocum[i].abrevUnidad)
                          }
                        }   
                      }
                    }
                  }

 

                  if(descrMetodo && descrTarea){
console.time(5)      
console.log("Inicia 5")
                    let indexMet = allMetodo.findIndex( metodo => metodo.descrMetodo===descrMetodo )
                    if(indexMet===-1){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => El método ${descrMetodo} no ha sido creado`});
                    }
                    let indexTarea = allTarea.findIndex( tarea => tarea.descrTarea===descrTarea )
                    if(indexTarea===-1){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => La tarea ${descrTarea} no ha sido creada`});
                    }
                    let indexFrecuencia = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===descrFrecuencia )
                    if(indexFrecuencia===-1){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => La frecuencia ${descrFrecuencia} no ha sido creada`});
                    }
                    if(!modoTarea || (modoTarea!=='I' && modoTarea!=='O')){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => El modo de ejecución de la tarea solo puedes O (En parada) o I (En ejecución)`});
                    }
                    if(!requiereSISO || (requiereSISO!=='Si' && requiereSISO!=='No')){
                      errors.push({path: "Cargue", message: `Línea: ${i + 1} => El campo Requiere SISO solo puede ser Si o No)`});
                    }
                    codProcedimiento = codProcedimiento.replace(/(\r\n|\n|\r)/gm,"")
                    if (codProcedimiento!==null && codProcedimiento!==''){
                      let indexProc = allProcEjec.findIndex( procejec => procejec.codProcedimiento==codProcedimiento )
                      if(indexProc===-1){
                        errors.push({path: "Cargue", message: `Línea: ${i + 1} => El procedimiento ${codProcedimiento} no ha sido creado`});
                      }   
                    }
                    codInfoTarea = codInfoTarea.replace(/(\r\n|\n|\r)/gm,"")
                    if (codInfoTarea!==null && codInfoTarea!==''){
                      let indexInfo = allInfoTarea.findIndex( infotarea => infotarea.codInfoTarea==codInfoTarea )
                      if(indexInfo===-1){
                        errors.push({path: "Cargue", message: `Línea: ${i + 1} => El código de advertencia ${codInfoTarea} no ha sido creado`});
                      }   
                    } 
console.timeEnd(5)      
console.log("Finaliza 5")  
                  }
                  // argsProg = llenar_argsProg(listMt[ii], allProcEjec, allInfoTarea, fechaHoraHoy)
                  argsProg = llenar_argsProg(listMt[ii], allProcEjec, allInfoTarea, fechaHoraHoy)
                  addColeccProg.push(argsProg)
                  argsProg = {}

                  i += 1
                }
console.timeEnd(4)      
console.log("Finaliza 4")

                let descrEmpresa1 = "", descrPlanta1 = "", descrSeccion1 = "", descrEquipo1 = ""
                let descrComponente1 = ""
                if(i<listDocum.length){
                  descrEmpresa1 = listDocum[i].descrEmpresa
                  descrPlanta1 = listDocum[i].descrPlanta
                  descrSeccion1 = listDocum[i].descrSeccion
                  descrEquipo1 = listDocum[i].descrEquipo
                  descrComponente1 = listDocum[i].descrComponente
                }
console.time(6)      
console.log("Inicia 6")
                argsMec2 = llenar_argsMec2(listDocum[lineaDoc], addColeccProg, fechaHoraHoy)
                argsMec = Object.assign({}, argsMec1, argsMec2);
console.timeEnd(6)      
console.log("Finaliza 6")
                addColeccMec.push(argsMec)
                argsMec = {}
                argsMec1 = {}
                argsMec2 = {}
                addColeccProg = []
                
console.time(7)      
console.log("Inicia 7")                
                
                // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
                // argsBuscarPl = {}
                // argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
                // regExiste = []
                // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                // regExiste = await data.allPlantaRtes
                // let idPlanta = regExiste[0]&&regExiste[0].idPlanta?regExiste[0].idPlanta:0

                let indexPla = allPlanta.findIndex( empresa => empresa.descrEmpresa===descrEmpresa && empresa.descrPlanta===descrPlanta)
                let idPlanta = indexPla===-1?0:allPlanta[indexPla].idPlanta


console.timeEnd(7)      
console.log("Finaliza 7")

                // if(regExiste.length===0){
                if(indexPla===-1){
        //PLANTA NUEVA
                  if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                    descrEquipo!==descrEquipo1||descrComponente!==descrComponente1){
console.time(8)      
console.log("Inicia 8")
                    argsComp = llenar_argsComp(listDocum[lineaDoc], addColeccMec, fechaHoraHoy)
console.timeEnd(8)      
console.log("Finaliza 8")
                    addColeccComp.push(argsComp)
                    argsComp = {}
                    addColeccMec = []
                  }
                  if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                    descrEquipo!==descrEquipo1){
                    argsEqu['codEquipo'] = listDocum[lineaDoc].codEquipo
                    argsEqu['numCarta'] = parseInt(listDocum[lineaDoc].numCarta)
                    argsEqu['descrEquipo'] = listDocum[lineaDoc].descrEquipo
                    argsEqu['componentes'] = addColeccComp
                    argsEqu['fechaCreate'] = fechaHoraHoy
                    argsEqu['usuarioCreate'] = localStorage.getItem('userLogin')
                    addColeccEqu.push(argsEqu)
                    argsEqu = {}
                    addColeccComp = []
                  }
                  if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1){
                    argsSecc['codSeccion'] = listDocum[lineaDoc].codSeccion
                    argsSecc['descrSeccion'] = listDocum[lineaDoc].descrSeccion
                    argsSecc['equipos'] = addColeccEqu
                    argsSecc['fechaCreate'] = fechaHoraHoy
                    argsSecc['usuarioCreate'] = localStorage.getItem('userLogin')
                    addColeccSecc.push(argsSecc)
                    argsSecc = {}
                    addColeccEqu = []
                  }
                  if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1){
                    argsPl['codPlanta'] = listDocum[lineaDoc].codPlanta
                    argsPl['descrPlanta'] = listDocum[lineaDoc].descrPlanta
                    argsPl['descrEmpresa'] = listDocum[lineaDoc].descrEmpresa
                    argsPl['secciones'] = addColeccSecc
                    argsPl['fechaCreate'] = fechaHoraHoy
                    argsPl['usuarioCreate'] = localStorage.getItem('userLogin')
                    argsPl['tipoAct'] = "CrearPlanta"
                    addColeccPl.push(argsPl)
                    argsPl = {}
                    addColeccSecc = []
                  }
                  i -= 1
                  // console.log("Crear Planta")
        //FIN PLANTA NUEVA
                }else{
console.time(9)      
console.log("Inicia 9")                  
                  // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
                  // argsBuscar += `, 'descrSeccion': '${descrSeccion}'`
                  // argsBuscarPl = {}
                  // argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
                  // // console.log(argsBuscarPl)
                  // regExiste = []
                  // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                  // regExiste = await data.allPlantaRtes

                  let indexSec = allPlanta.findIndex( empresa => empresa.descrEmpresa===descrEmpresa && empresa.descrPlanta===descrPlanta &&
                    empresa.descrSeccion===descrSeccion)
  


console.timeEnd(9)      
console.log("Finaliza 9")                  
                  // if(regExiste.length===0){
                  if(indexSec===-1){
                      //SECCION NUEVA
                    if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                        descrEquipo!==descrEquipo1||descrComponente!==descrComponente1){
                     
console.time(10)      
console.log("Inicia 10")                     
                      argsComp = llenar_argsComp(listDocum[lineaDoc], addColeccMec, fechaHoraHoy)
console.timeEnd(10)      
console.log("Finaliza 10")                       
                      addColeccComp.push(argsComp)
                      argsComp = {}
                      addColeccMec = []
                    }
                    if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                      descrEquipo!==descrEquipo1){
                      argsEqu['codEquipo'] = listDocum[lineaDoc].codEquipo
                      argsEqu['numCarta'] = parseInt(listDocum[lineaDoc].numCarta)
                      argsEqu['descrEquipo'] = listDocum[lineaDoc].descrEquipo
                      argsEqu['componentes'] = addColeccComp
                      argsEqu['fechaCreate'] = fechaHoraHoy
                      argsEqu['usuarioCreate'] = localStorage.getItem('userLogin')
                      addColeccEqu.push(argsEqu)
                      argsEqu = {}
                      addColeccComp = []
                    }
                    if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1){
                      argsSecc['codSeccion'] = listDocum[lineaDoc].codSeccion
                      argsSecc['descrSeccion'] = listDocum[lineaDoc].descrSeccion
                      argsSecc['equipos'] = addColeccEqu
                      argsSecc['fechaCreate'] = fechaHoraHoy
                      argsSecc['usuarioCreate'] = localStorage.getItem('userLogin')
                      addColeccSecc.push(argsSecc)
                      argsSecc = {}
                      addColeccEqu = []
                      
                      argsPl['_id'] = idPlanta
                      argsPl['codPlanta'] = listDocum[lineaDoc].codPlanta
                      argsPl['descrPlanta'] = listDocum[lineaDoc].descrPlanta
                      // argsPl['descrEmpresa'] = listDocum[lineaDoc].descrEmpresa
                      argsPl['secciones'] = addColeccSecc
                      argsPl['tipoAct'] = "CrearSeccion"
                      addColeccPl.push(argsPl)
                      argsPl = {}
                      addColeccSecc = []
                    }
                    i -= 1
                    // console.log("Crear Seccion")
        //FIN SECCION NUEVA
                  }else{
console.time(11)      
console.log("Inicia 11")         
                    // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
                    // argsBuscar += `, 'descrSeccion': '${descrSeccion}', 'descrEquipo': '${descrEquipo}'`
                    // argsBuscarPl = {}
                    // argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
                    // regExiste = []
                    // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                    // regExiste = await data.allPlantaRtes

                    let indexEq = allPlanta.findIndex( empresa => empresa.descrEmpresa===descrEmpresa && empresa.descrPlanta===descrPlanta &&
                      empresa.descrSeccion===descrSeccion && empresa.descrEquipo===descrEquipo)

console.timeEnd(11)      
console.log("Finaliza 11")                     
                      

                    // if(regExiste.length===0){
                    if(indexEq===-1){
                        //EQUIPO NUEVO
                      if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                          descrEquipo!==descrEquipo1||descrComponente!==descrComponente1){
console.time(12)      
console.log("Inicia 12")                         
                        argsComp = llenar_argsComp(listDocum[lineaDoc], addColeccMec, fechaHoraHoy)
console.timeEnd(12)      
console.log("Finaliza 12")                         
                        addColeccComp.push(argsComp)
                        argsComp = {}
                        addColeccMec = []
                      }
                      if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                        descrEquipo!==descrEquipo1){
                        argsEqu['codEquipo'] = listDocum[lineaDoc].codEquipo
                        argsEqu['numCarta'] = parseInt(listDocum[lineaDoc].numCarta)
                        argsEqu['descrEquipo'] = listDocum[lineaDoc].descrEquipo
                        argsEqu['descrPrograma'] = listDocum[lineaDoc].descrPrograma?listDocum[lineaDoc].descrPrograma:'Sin programa'
                        argsEqu['componentes'] = addColeccComp
                        argsEqu['fechaCreate'] = fechaHoraHoy
                        argsEqu['usuarioCreate'] = localStorage.getItem('userLogin')
                        argsEqu['fechaAcum'] = fechaHoraHoy
                        argsEqu['usuarioAcum'] = localStorage.getItem('userLogin')
                        addColeccEqu.push(argsEqu)
                        argsEqu = {}
                        addColeccComp = []

                        argsSecc['descrSeccion'] = listDocum[lineaDoc].descrSeccion
                        argsSecc['equipos'] = addColeccEqu
                        addColeccSecc.push(argsSecc)
                        argsPl['secciones'] = addColeccSecc

                        argsPl['_id'] = idPlanta
                        argsPl['descrPlanta'] = listDocum[lineaDoc].descrPlanta
                        argsPl['tipoAct'] = "CrearEquipo"
                        addColeccPl.push(argsPl)
                        argsPl = {}
                        addColeccSecc = []
                        argsSecc = {}
                        addColeccEqu = []
                      }
                      i -= 1
                      // console.log("Crear Equipo")
        //FIN EQUIPO NUEVO
                    }else{
console.time(13)      
console.log("Inicia 13")                       
                      // argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
                      // argsBuscar += `, 'descrSeccion': '${descrSeccion}', 'descrEquipo': '${descrEquipo}'`
                      // argsBuscar += `, 'descrComponente': '${descrComponente}'`
                      // argsBuscarPl = {}
                      // argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
                      // regExiste = []
                      // let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                      // regExiste = await data.allPlantaRtes

                      let indexComp = allPlanta.findIndex( empresa => empresa.descrEmpresa===descrEmpresa && empresa.descrPlanta===descrPlanta &&
                        empresa.descrSeccion===descrSeccion && empresa.descrEquipo===descrEquipo &&
                        empresa.descrComponente===descrComponente)
  
console.timeEnd(13)      
console.log("Finaliza 13")                       
                      // if(regExiste.length===0){
                      if(indexComp===-1){
                          //COMPONENTE NUEVO
                        if(descrEmpresa!==descrEmpresa1||descrPlanta!==descrPlanta1||descrSeccion!==descrSeccion1||
                            descrEquipo!==descrEquipo1||descrComponente!==descrComponente1){
                          argsComp = llenar_argsComp(listDocum[lineaDoc], addColeccMec, fechaHoraHoy)
          
                          addColeccComp.push(argsComp)
                          argsComp = {}
                          addColeccMec = []

                          argsEqu['descrEquipo'] = listDocum[lineaDoc].descrEquipo
                          argsEqu['componentes'] = addColeccComp
                          addColeccEqu.push(argsEqu)
                          argsSecc['descrSeccion'] = listDocum[lineaDoc].descrSeccion
                          argsSecc['equipos'] = addColeccEqu
                          addColeccSecc.push(argsSecc)
                          argsPl['secciones'] = addColeccSecc

                          argsPl['_id'] = idPlanta
                          argsPl['descrPlanta'] = listDocum[lineaDoc].descrPlanta
                          argsPl['tipoAct'] = "CrearComponente"
                          addColeccPl.push(argsPl)
                          argsPl = {}
                          addColeccSecc = []
                          argsSecc = {}
                          addColeccEqu = []
                          argsEqu = {}
                          addColeccComp = []  
                        }
                        i -= 1
                        // console.log("Crear Componente")
        //FIN COMPONENTE NUEVO
                      }else{
        //MECANISMO NUEVO
                        argsComp['descrComponente'] = listDocum[lineaDoc].descrComponente
                        argsComp['mecanismos'] = addColeccMec
                        addColeccComp.push(argsComp)

                        argsEqu['descrEquipo'] = listDocum[lineaDoc].descrEquipo
                        argsEqu['componentes'] = addColeccComp
                        addColeccEqu.push(argsEqu)
                        argsSecc['descrSeccion'] = listDocum[lineaDoc].descrSeccion
                        argsSecc['equipos'] = addColeccEqu
                        addColeccSecc.push(argsSecc)
                        argsPl['secciones'] = addColeccSecc

                        argsPl['_id'] = idPlanta
                        argsPl['descrPlanta'] = listDocum[lineaDoc].descrPlanta
                        argsPl['tipoAct'] = "CrearMecanismo"
                        addColeccPl.push(argsPl)
                        argsPl = {}
                        addColeccSecc = []
                        argsSecc = {}
                        addColeccEqu = []
                        argsEqu = {}
                        addColeccComp = []
                        argsComp = {}
                        addColeccMec = []    

                        i -= 1
                        // console.log("Crear Mecanismo")
        //FIN MECANISMO NUEVO
                      }
                    }
                  }
                }
      //FIN ADD
              }
console.timeEnd(1)      
console.log("Finaliza Registro ", i)
            }
            if(errors.length>0){
              this.setState({errors})
            }else{
console.time(14)      
console.log("Inicia 14")               
              let creaColecc1 = [], addColeccPl1 = [], addColeccSecc = [], addColeccSecc1 = []
              let addColeccEq = [], addColeccEq1 = [], addColeccComp = [], addColeccComp1 = []
              let addColeccMec = [], addColeccMec1 = []
              let addColeccProg = [], addColeccProg1 = [], updColeccProg = [], updColeccProg1 = []
              for(let iii=0; iii<addColeccPl.length; iii++){
                if(addColeccPl[iii].tipoAct==="CrearPlanta"){
                  delete addColeccPl[iii].tipoAct
                  addColeccPl1.push(addColeccPl[iii])
                }
                if(addColeccPl[iii].tipoAct==="CrearSeccion"){
                  addColeccSecc.push(addColeccPl[iii])
                }
                if(addColeccPl[iii].tipoAct==="CrearEquipo"){
                  addColeccEq.push(addColeccPl[iii])
                }
                if(addColeccPl[iii].tipoAct==="CrearComponente"){
                  addColeccComp.push(addColeccPl[iii])
                }
                if(addColeccPl[iii].tipoAct==="CrearMecanismo"){
                  addColeccMec.push(addColeccPl[iii])
                }
                if(addColeccPl[iii].tipoAct==="CrearProgramacion"){
                  addColeccProg.push(addColeccPl[iii])
                }
                if(addColeccPl[iii].tipoAct==="EditarProgramacion"){
                  updColeccProg.push(addColeccPl[iii])
                }
              }

              addColeccSecc1.push({planta: addColeccSecc})
              addColeccEq1.push({planta: addColeccEq})
              addColeccComp1.push({planta: addColeccComp})
              addColeccMec1.push({planta: addColeccMec})
              addColeccProg1.push({planta: addColeccProg})
              updColeccProg1.push({planta: updColeccProg})
              creaColecc1.push({planta: addColeccPl1})

              let numDocCRUD = 0
              let totDocCRUD = 7
              let argsCrud = []
              let crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.createPlantaMany)
              }

              argsCrud[numDocCRUD] = addColeccSecc1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaEstructura
        
              numDocCRUD += 1

              argsCrud[numDocCRUD] = addColeccEq1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaEstructura
        
              numDocCRUD += 1

              argsCrud[numDocCRUD] = addColeccComp1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaEstructura
        
              numDocCRUD += 1

              argsCrud[numDocCRUD] = addColeccMec1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaEstructura
        
              numDocCRUD += 1

              argsCrud[numDocCRUD] = addColeccProg1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaEstructura
        
              numDocCRUD += 1

              argsCrud[numDocCRUD] = updColeccProg1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editPlantaEstructura
        
              numDocCRUD += 1

              argsCrud[numDocCRUD] = creaColecc1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.createPlantaMany
          
    //  console.log(argsCrud)
              this.updColecc(crudColecc, argsCrud, totDocCRUD)
              this.setState({listDocum: []})
console.timeEnd(14)      
console.log("Finaliza 14") 
            }
          
            document.body.style.cursor = 'default'

            if(errors.length===0){
              alert("!! Carga exitosa !!")
            }
          }
        }else{
          document.body.style.cursor = 'wait'
          let allLubricante = this.props.allLubricante.allLubricante
          let allAplicacion = this.props.allAplicacion.allAplicacion
          let allUtilidad = this.props.allUtilidad.allUtilidad
          let allUnidad = this.props.allUnidad.allUnidad
          let allGrado = this.props.allGrado.allGrado
          let errors = []
          for(let i=0; i<listDocum.length; i++){
            let argsBuscarPl = {}
            let regExiste = []
            let argsBuscar = ""
            let descrEmpresa = listDocum[i].descrEmpresa, descrPlanta = listDocum[i].descrPlanta
            let descrSeccion = listDocum[i].descrSeccion, descrEquipo = listDocum[i].descrEquipo
            let descrComponente = listDocum[i].descrComponente, descrMecanismo = listDocum[i].descrMecanismo

            if(!descrEmpresa){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Empresa NO REPORTADA`});
            }
            if(!descrPlanta){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Planta NO REPORTADA`});
            }
            if(!descrSeccion){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Sección NO REPORTADA`});
            }
            if(!descrEquipo){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Equipo NO REPORTADO`});
            }
            if(!descrComponente){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Componente NO REPORTADO`});
            }
            if(!descrMecanismo){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Mecanismo NO REPORTADO`});
            }

            argsBuscar = `'descrEmpresa': '${descrEmpresa}', 'descrPlanta': '${descrPlanta}'`
            argsBuscar += `, 'descrSeccion': '${descrSeccion}', 'descrEquipo': '${descrEquipo}'`
            argsBuscar += `, 'descrComponente': '${descrComponente}', 'descrMecanismo': '${descrMecanismo}'`
            argsBuscarPl = {}
            argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
            regExiste = []
              let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
              regExiste = await data.allPlantaRtes

            if(regExiste.length===0 && this.props.tipoCargue==="Upd"){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} MECANISMO NO EXISTE`});
            }          

            let indexUnd = allUnidad.findIndex( unidad => unidad.abrevUnidad===listDocum[i].abrevUnidad )
            if(indexUnd===-1){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} La unidad ${listDocum[i].abrevUnidad} no ha sido creada`});
            }
            let indexApli = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===listDocum[i].descrAplicacion )
            if(indexApli===-1){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} La aplicación ${listDocum[i].descrAplicacion} no ha sido creada`});
            }
            let indexUt = allUtilidad.findIndex( utilidad => utilidad.descrUtilidad===listDocum[i].descrUtilidad )
            // if(indexUt===-1){
            //   errors.push({path: "Cargue", message: `Línea: ${i + 1} El tipo de mecanismo ${listDocum[i].descrUtilidad} no ha sido creado`});
            // }
            let indexLub = allLubricante.findIndex( lubricante => lubricante.descrLubricante===listDocum[i].descrLubricante )
            if(indexLub===-1){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El lubricante ${listDocum[i].descrLubricante} no ha sido creado`});
            }else{
              let indexGra = allGrado.findIndex( grado => grado.descrGrado===allLubricante[indexLub].descrGrado )
              if(indexGra===-1){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El grado ${allLubricante[indexLub].descrGrado} no ha sido creado`});
              }
            }
          }

          document.body.style.cursor = 'default'

          this.setState({errors})
          if(errors.length===0){

      //PROCESO ACTUALIZAR ESTRUCTURA
            document.body.style.cursor = 'wait'

            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            for(let i=0; i<listDocum.length; i++){
              console.log(listDocum[i])
              let argsPl = {}, updColeccPl = []
              let argsMec = {}, updColeccMec = []
              let argsComp = {}, updColeccComp = []
              let argsEqu = {}, updColeccEqu = []
              let argsSecc = {}, updColeccSecc = []
              let descrUtilidad = ''
              // let lineaDoc = 0

              let indexUnd = allUnidad.findIndex( unidad => unidad.abrevUnidad===listDocum[i].abrevUnidad )
              let descrUnidad = allUnidad[indexUnd].descrUnidad
              let indexApli = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===listDocum[i].descrAplicacion )
              let descrAplicacion = allAplicacion[indexApli].descrAplicacion
              let indexUt = allUtilidad.findIndex( utilidad => utilidad.descrUtilidad===listDocum[i].descrUtilidad )
              if(indexUt!==-1){
                let descrUtilidad = allUtilidad[indexUt].descrUtilidad
              }
              let colorAplicacion = allAplicacion[indexApli].color
              let indexLub = allLubricante.findIndex( lubricante => lubricante.descrLubricante===listDocum[i].descrLubricante )
              let descrLubricante = allLubricante[indexLub].descrLubricante
              let tipoLub = allLubricante[indexLub].tipoLub
              let claseLub = allLubricante[indexLub].claseLub
              let descrFabricante = allLubricante[indexLub].descrFabricante
              let categoriaLub = allLubricante[indexLub].categoriaLub
              let tipoGrado = allLubricante[indexLub].tipoGrado
              let descrGrado = allLubricante[indexLub].descrGrado
              let colorGrado = allLubricante[indexLub].colorGrado
              let apiSAE = allLubricante[indexLub].apiSAE?allLubricante[indexLub].apiSAE:""
              let isoGrasa = allLubricante[indexLub].isoGrasa?allLubricante[indexLub].isoGrasa:""
              let isoGrasaColor = allLubricante[indexLub].isoGrasaColor?allLubricante[indexLub].isoGrasaColor:""
              let isoGrasaTexto = allLubricante[indexLub].isoGrasaTexto?allLubricante[indexLub].isoGrasaTexto:""          
              let indexGra = allGrado.findIndex( grado => grado.descrGrado===allLubricante[indexLub].descrGrado )
              let colorTexto = allGrado[indexGra].colorTexto

              let descrEmpresa = listDocum[i].descrEmpresa, descrPlanta = listDocum[i].descrPlanta
              let descrSeccion = listDocum[i].descrSeccion, descrEquipo = listDocum[i].descrEquipo
              let descrComponente = listDocum[i].descrComponente, descrMecanismo = listDocum[i].descrMecanismo
              let codPlanta = listDocum[i].codPlanta?listDocum[i].codPlanta:''
              let codSeccion = listDocum[i].codSeccion?listDocum[i].codSeccion:''
              let codEquipo = listDocum[i].codEquipo?listDocum[i].codEquipo:''
              let descrPrograma = listDocum[i].descrPrograma?listDocum[i].descrPrograma:'Sin programa'
              let codComponente = listDocum[i].codComponente?listDocum[i].codComponente:''
              let codMecanismo = listDocum[i].codMecanismo?listDocum[i].codMecanismo:''
              let abrevUnidad = listDocum[i].abrevUnidad
              let tipoFrecuencia = listDocum[i].tipoFrecuencia
              let cantidadTotal = listDocum[i].cantidadTotal?listDocum[i].cantidadTotal:0
              
              
              // argsPl['descrMecanismo'] = descrMecanismo
              // argsPl['codMecanismo'] = codMecanismo
              // argsPl['descrUnidad'] = descrUnidad
              // argsPl['abrevUnidad'] = abrevUnidad
              // argsPl['cantidadTotal'] = cantidadTotal
              // argsPl['descrLubricante'] = descrLubricante
              // argsPl['tipoFrecuencia'] = tipoFrecuencia
              // argsPl['descrAplicacion'] = descrAplicacion
              // argsPl['colorAplicacion'] = colorAplicacion
              // argsPl['tipoLub'] = tipoLub
              // argsPl['claseLub'] = claseLub
              // argsPl['descrFabricante'] = descrFabricante
              // argsPl['categoriaLub'] = categoriaLub
              // argsPl['tipoGrado'] = tipoGrado
              // argsPl['descrGrado'] = descrGrado
              // argsPl['colorGrado'] = colorGrado
              // argsPl['apiSAE'] = apiSAE
              // argsPl['isoGrasa'] = isoGrasa
              // argsPl['isoGrasaColor'] = isoGrasaColor
              // argsPl['isoGrasaTexto'] = isoGrasaTexto
              // argsPl['colorTexto'] = colorTexto

              // argsPl['descrComponente'] = descrComponente
              // argsPl['codComponente'] = codComponente
              // argsPl['descrEquipo'] = descrEquipo
              // argsPl['codEquipo'] = codEquipo    
              // argsPl['descrSeccion'] = descrSeccion
              // argsPl['codSeccion'] = codSeccion
              // argsPl['descrEmpresa'] = descrEmpresa
              // argsPl['descrPlanta'] = descrPlanta
              // argsPl['codPlanta'] = codPlanta
              // argsPl['tipoAct'] = 'EditarEstructura'
              // updColeccPl.push(argsPl)
              
              // let numDocCRUD = 0
              // let totDocCRUD = 1
              // let argsCrud = []
              // let crudColecc = []
              // for(let iii=0; iii<totDocCRUD; iii++){
              //   argsCrud.push({ctrlCampo: 'NO_CRUD'})
              // }
              // for(let iii=0; iii<totDocCRUD; iii++){
              //   crudColecc.push(this.props.editPlantaUpdSeccion)
              // }

              // argsCrud[numDocCRUD] = updColeccPl[0]
              // argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              // argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              // crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion

              // console.log(argsCrud)
              // this.updColecc(crudColecc, argsCrud, totDocCRUD)




              const argsUpd = {
                descrEmpresa: descrEmpresa,
                codPlanta: codPlanta,
                descrPlanta: descrPlanta,
                codSeccion: codSeccion,
                descrSeccion: descrSeccion,
                codEquipo: codEquipo,
                descrEquipo: descrEquipo,
                descrPrograma: descrPrograma?descrPrograma:'Sin programa',
                codComponente: codComponente,
                descrComponente: descrComponente,
                codMecanismo: codMecanismo,
                descrMecanismo: descrMecanismo,
                descrLubricante: descrLubricante,
                descrUtilidad: descrUtilidad, 
                descrAplicacion: descrAplicacion,
                colorAplicacion:colorAplicacion,           
                tipoFrecuencia: tipoFrecuencia,
                descrUnidad: descrUnidad,
                abrevUnidad: abrevUnidad,
                cantidadTotal: cantidadTotal,
                tipoLub: tipoLub, 
                claseLub: claseLub,            
                descrFabricante: descrFabricante,            
                categoriaLub: categoriaLub,            
                tipoGrado: tipoGrado,   
                descrGrado: descrGrado,            
                colorGrado: colorGrado,            
                apiSAE: apiSAE,   
                colorTexto: colorTexto,
                isoGrasa: isoGrasa,   
                isoGrasaColor: isoGrasaColor,   
                isoGrasaTexto: isoGrasaTexto,   
                tipoAct: 'EditarEstructura' 
              } 
              console.log(argsUpd)
              let response = await this.props.editPlantaUpdSeccion({variables: argsUpd});

              // addColeccProg = []
      //FIN UPD
            }
            if(errors.length>0){
              this.setState({errors})
            }else{

              
              this.setState({listDocum: []})
            }
          
            document.body.style.cursor = 'default'

            if(errors.length===0){
              alert("!! Carga exitosa !!")
            }
          }        
        }  
      }
    }
    // console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  // async componentDidUpdate(prevProps){

  // }

  render(){
    const {listDocum, checked, permiteUpdate, confirmaAct, open, errors} = this.state;
    let mensaje = "PROCESAR ARCHIVO"
    let imgIcon = "images/archivo_32.png"
// console.log(this.props.tipoCargue)
    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input
// console.log("Prueba render")
    let tit1 = "Cargar estructura NUEVA"
    let tit2 = "Procesar archivo de Estructura - NUEVO"
    if(this.props.tipoCargue==="Upd"){
      tit1 = "ACTUALIZAR estructura"
      tit2 = "Procesar archivo de Estructura - ACTUALIZAR"
    }
    if(this.props.tipoCargue==="UpdEq"){
      tit1 = "ORDENAR EQUIPOS"
      tit2 = "Procesar archivo para ORDENAR EQUIPOS"
    }  
    if(this.props.tipoCargue==="UpdEqAc"){
      tit1 = "ACUMULADOS DE Horas/Km DE EQUIPOS"
      tit2 = "Procesar archivo para ACT. ACUM. DE EQUIPOS"
    }    
    if(this.props.tipoCargue==="UpdEq"){
      return(
        <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              {tit1}
          </button>
          <div>
            <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
              <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
                <div>
                  <div className="ui one column stackable grid">
                      <div className="row container">
                          <div className="column" style={{width: '100%'}}>
                            <h1 style={{color: '#2C7744'}}>{tit2}</h1>
                          </div>
                      </div>
                  </div>
                  <hr></hr>
                  <hr></hr>
                  <br/>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Seleccionar archivo CSV...&nbsp;&nbsp;
                        </label>

                        <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                        {/* <output id="out" style={estilos1}>
                            file contents will appear here
                        </output> */}
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                            <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                    name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                            &nbsp;&nbsp;Tiene encabezados en la primera fila
                          </p>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <hr></hr>
                  <hr></hr>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Total documentos:&nbsp;
                    {listDocum.length}
                  </p>

                  <div className="ui one column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '100%'}}>
                        <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                      </div>
                    </div>
                  </div>
                  <hr></hr>

                  {
                      errors.length?<Message negative header="Los siguientes errores:"
                      list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                  <div style={{height: '40em', overflow: 'auto'}}>
                    <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                      <thead className=''>
                        <tr className=''>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Operario</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Número de carta</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>programa equipo</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Imagen</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Orden de imagen</th>
                        </tr>
                      </thead>
                      <ListaDocum list={listDocum} tipoCargue={this.props.tipoCargue}/>
                    </table>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )    
    }else{
      if(this.props.tipoCargue==="UpdEqAc"){
        return(
          <div>
            <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                {tit1}
            </button>
            <div>
              <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
                  <div>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" style={{width: '100%'}}>
                              <h1 style={{color: '#2C7744'}}>{tit2}</h1>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <hr></hr>
                    <br/>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Seleccionar archivo CSV...&nbsp;&nbsp;
                          </label>
  
                          <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>
  
                          {/* <output id="out" style={estilos1}>
                              file contents will appear here
                          </output> */}
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <Form.Field>
                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                              <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                              &nbsp;&nbsp;Tiene encabezados en la primera fila
                            </p>
                          </Form.Field>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <hr></hr>
                    <hr></hr>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Total documentos:&nbsp;
                      {listDocum.length}
                    </p>
  
                    <div className="ui one column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '100%'}}>
                          <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                        </div>
                      </div>
                    </div>
                    <hr></hr>
  
                    {
                        errors.length?<Message negative header="Los siguientes errores:"
                        list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                    }
                    <div style={{height: '40em', overflow: 'auto'}}>
                      <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Acumulado</th>
                            {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Acum. prox. ejec.</th> */}
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de frecuencia</th>
                          </tr>
                        </thead>
                        <ListaDocum list={listDocum} tipoCargue={this.props.tipoCargue}/>
                      </table>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )    
      }else{ 
        if(this.props.tipoCargue==="Add"){     
          return(
          <div>
            <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                {tit1}
            </button>
            {/* <a style={{color: 'blue'}}
              href='images/documentos/formato_cargue_masivo.csv' target="_blank">
              Descargar formato
            </a> */}
            <div>
              <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
                  <div>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" style={{width: '100%'}}>
                              <h1 style={{color: '#2C7744'}}>{tit2}</h1>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <hr></hr>
                    <br/>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Seleccionar archivo CSV...&nbsp;&nbsp;
                          </label>

                          <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                          {/* <output id="out" style={estilos1}>
                              file contents will appear here
                          </output> */}
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <Form.Field>
                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                              <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                      name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                              &nbsp;&nbsp;Tiene encabezados en la primera fila
                            </p>
                          </Form.Field>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <hr></hr>
                    <hr></hr>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Total documentos:&nbsp;
                      {listDocum.length}
                    </p>

                    <div className="ui one column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '100%'}}>
                          <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                        </div>
                      </div>
                    </div>
                    <hr></hr>

                    {
                        errors.length?<Message negative header="Los siguientes errores:"
                        list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                    }
                    <div style={{height: '40em', overflow: 'auto'}}>
                      <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Consecutivo</th>  
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Planta</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Sección</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Equipo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Componente</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Mecanismo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aplicación</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de mecanismo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant Total</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cantidad</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Puntos a Lub</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>tipoFrecuencia</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Minutos ejec.</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Método de Lub</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tarea de Lub</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Modo ejec. tarea</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Requiere ISO</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>tipoFrecuencia</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Frecuencia</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Frecuencia Predictiva</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha Inicial</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Procedimiento</th>
                            {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Advertencia</th> */}
                          </tr>
                        </thead>
                        <ListaDocum list={listDocum} tipoCargue={this.props.tipoCargue}/>
                      </table>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )
      }else{
        return(
          <div>
            <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                {tit1}
            </button>
            {/* <a style={{color: 'blue'}}
              href='images/documentos/formato_cargue_masivo.csv' target="_blank">
              Descargar formato
            </a> */}
            <div>
              <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
                  <div>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" style={{width: '100%'}}>
                              <h1 style={{color: '#2C7744'}}>{tit2}</h1>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <hr></hr>
                    <br/>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Seleccionar archivo CSV...&nbsp;&nbsp;
                          </label>

                          <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                          {/* <output id="out" style={estilos1}>
                              file contents will appear here
                          </output> */}
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <Form.Field>
                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                              <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                      name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                              &nbsp;&nbsp;Tiene encabezados en la primera fila
                            </p>
                          </Form.Field>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <hr></hr>
                    <hr></hr>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Total documentos:&nbsp;
                      {listDocum.length}
                    </p>

                    <div className="ui one column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '100%'}}>
                          <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                        </div>
                      </div>
                    </div>
                    <hr></hr>

                    {
                        errors.length?<Message negative header="Los siguientes errores:"
                        list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                    }
                    <div style={{height: '40em', overflow: 'auto'}}>
                      <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                        <thead className=''>
                          <tr className=''>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Planta</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Sección</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Equipo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Componente</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Mecanismo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de mecanismo</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aplicación</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant Total</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                            <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Puntos a Lub</th>
                          </tr>
                        </thead>
                        <ListaDocum list={listDocum} tipoCargue={this.props.tipoCargue}/>
                      </table>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )
      }
      }
    }
  }
}

export default compose(
  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.query.allUtilidad, {name:'allUtilidad'}),
  graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.query.allMetodo, {name:'allMetodo'}),
  graphql(queries.query.allTarea, {name:'allTarea'}),
  graphql(queries.query.allGrado, {name:'allGrado'}),
  graphql(queries.query.allProcEjec, {name:'allProcEjec'}),
  graphql(queries.query.allInfoTarea, {name:'allInfoTarea'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allPrograma, {name:'allPrograma'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.mutation.createPlantaMany, {name:'createPlantaMany'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),
  graphql(queries.mutation.editPlanta, {name:'editPlanta'}),
  
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(CargEst2)
